import type { FC } from 'react';
import type { SidebarEmptyStateProps } from '../../types';

const resolveMessage = ({ canCreate, disabledReason, isFreePlan }: SidebarEmptyStateProps) => {
  if (canCreate) {
    return 'No personal meetings yet. Click "ADD NEW MEETING ID" to create one.';
  }
  if (isFreePlan) {
    return 'No personal meetings available';
  }
  return disabledReason ?? 'Personal meetings are not available.';
};

const EmptyState: FC<SidebarEmptyStateProps> = (props) => {
  const message = resolveMessage(props);

  return (
    <div className="personal-meetings-modal__empty">
      <p>{message}</p>
    </div>
  );
};

export default EmptyState;
